import {Injectable} from '@angular/core'; 
import { HttpClient,HttpParams, HttpHeaders } from '@angular/common/http'; 
//import {environment} from '../../environments/environment';
import {environment} from '../../environments/environment.prod';
@Injectable()
export class Httpclient {

  constructor(private http: HttpClient) {}

  createAuthorizationHeader(headers: Headers) {
    headers.append('x-access-token', localStorage.getItem('_uid'));
  }
 
  baseUrl=environment.apiendpoint;
  
  get(url) {
    let apiRouteUrl= this.baseUrl + url;
    var token = localStorage.getItem("_uid"); 
    if(token==null) {      
      token="";  
    }
    let headers = new HttpHeaders().set('x-access-token', token);
    return this.http.get(apiRouteUrl,{headers});
  }

  post(url, data) {
      
    
    let apiRouteUrl= this.baseUrl + url;
    var token = localStorage.getItem("_uid");
    if(token==null) {      
      token="";  
    }
    let headers = new HttpHeaders().set('x-access-token', token); 
    return this.http.post(apiRouteUrl, data, { headers });
    
  }
}